import type { KeycloakInitOptions } from 'keycloak-js'

import { isLocal } from '@/environments'

export const keycloakInitOptions: KeycloakInitOptions = {
  onLoad: 'login-required',
  // Use a stable redirect URI (root) so deep app routes don't have to be allowlisted
  // individually in Keycloak. The deep path is saved in tokenStore.redirect and
  // restored after login by InitializeAppMiddleware via tokenStore.useRedirect().
  redirectUri: `${location.origin}/`,
  silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
  responseMode: 'fragment',
  flow: 'standard',
  pkceMethod: 'S256',
  enableLogging: isLocal,
  checkLoginIframe: false,
}
